import {
  DesktopOutlined,
  ControlOutlined,
  CarryOutOutlined,
  SnippetsOutlined,
  UserOutlined,
  IdcardOutlined,
  QuestionCircleOutlined,
  FileProtectOutlined,
  FileOutlined,
  BlockOutlined,
  FilePdfOutlined,
  SettingOutlined,
  MailOutlined,
  MoneyCollectOutlined,
} from '@ant-design/icons';

export const menuKeys = [
  {
    key: 'home.dashboard',
    name: 'sider.dashboard',
    icon: DesktopOutlined,
    isAllowed: (permissions, role) => role?.toLowerCase() === 'admin',
  },
  {
    key: 'home.users',
    name: 'sider.users',
    icon: UserOutlined,
    isAllowed: (permissions, role) => role?.toLowerCase() === 'admin',
  },
  {
    key: 'home.roles',
    name: 'sider.roles',
    icon: IdcardOutlined,
    role: 'admin',
    isAllowed: (permissions, role) => role?.toLowerCase() === 'admin',
  },
  {
    key: 'home.permission',
    name: 'sider.permissions',
    icon: CarryOutOutlined,
    role: 'admin',
    isAllowed: (permissions, role) => role?.toLowerCase() === 'admin',
  },

  {
    key: 'home.configuration',
    name: 'sider.configurations',
    icon: FileProtectOutlined,
    isAllowed: (permissions, role) => role?.toLowerCase() === 'admin',
  },
  {
    key: 'home.email-template',
    name: 'sider.email.templates',
    icon: MailOutlined,
    isAllowed: (permissions, role) => role?.toLowerCase() === 'admin',
  },
  {
    key: 'home.pdf-template',
    name: 'sider.pdf.templates',
    icon: FilePdfOutlined,
    isAllowed: (permissions, role) => role?.toLowerCase() === 'admin',
  },
  {
    key: 'home.theme',
    name: 'sider.theming',
    icon: BlockOutlined,
    isAllowed: (permissions, role) => role?.toLowerCase() === 'admin',
  },
  {
    key: 'home.page',
    name: 'sider.static.pages',
    icon: FileOutlined,
    isAllowed: (permissions, role) => role?.toLowerCase() === 'admin',
  },
  {
    key: 'home.page-configuration',
    name: 'sider.system.pages.configuration',
    icon: SnippetsOutlined,
    isAllowed: (permissions, role) => role?.toLowerCase() === 'admin',
  },
  {
    key: 'home.system-log',
    name: 'System Logs',
    icon: SettingOutlined,
    isAllowed: (permissions, role) => role?.toLowerCase() === 'admin',
  },
  {
    key: 'home.audit-log',
    name: 'Audit log',
    icon: ControlOutlined,
    isAllowed: (permissions, role) => role?.toLowerCase() === 'admin',
  },
  {
    key: 'home.unsubscribed-emails',
    name: 'Unsubscribed Emails',
    icon: MailOutlined,

    isAllowed: (permissions, role) => role?.toLowerCase() === 'admin',
  },
  {
    key: 'home.categories',
    name: 'Categories',
    icon: FileOutlined,
    isAllowed: (permissions, role) => role?.toLowerCase() === 'admin',
  },
  {
    key: 'home.website-templates',
    name: 'Website Variants',
    icon: FileOutlined,
    isAllowed: (permissions, role) => role?.toLowerCase() === 'admin',
  },
  {
    key: 'home.websites',
    name: 'Websites',
    icon: FileOutlined,
  },
  {
    key: 'home.contact',
    name: 'sider.enquiries',
    icon: QuestionCircleOutlined,
    isAllowed: (permissions, role) => role?.toLowerCase() === 'admin',
  },
  {
    key: 'home.payment',
    name: 'Payment History',
    icon: MoneyCollectOutlined,
  },
  {
    key: 'home',
    name: 'System Settings',
    icon: SettingOutlined,

    children: [
      {
        key: 'home.email-settings',
        name: 'Email Settings',
        icon: FilePdfOutlined,
      },
      {
        key: 'home.sms-settings',
        name: 'SMS Settings',
        icon: MailOutlined,
      },
    ],
    isAllowed: (permissions, role) => role?.toLowerCase() === 'admin',
  },
  { key: 'settings.general', name: 'sider.settings', icon: SettingOutlined },
];
